import type { EnumFormatConfig } from './column-format-options';
import { tasStateLabelMap } from 'tio-data/models/tas-application';

// Re-export for consumers that need the map directly
export { tasStateLabelMap };

// Program instance labels use descriptive forms to avoid ambiguity in flat
// report/filter contexts where multiple states map to "Pending" or "Approved".
export const TAS_PROGRAM_INSTANCE_STATE_LABELS: Record<string, string> = {
  'TAS.ProgramInstanceState.CREATED': 'Created',
  'TAS.ProgramInstanceState.DRAFT': 'In Draft',
  'TAS.ProgramInstanceState.PENDING_PROGRAM_APPROVAL': 'Pending Program Approval',
  'TAS.ProgramInstanceState.PROGRAM_APPROVED': 'Program Approved',
  'TAS.ProgramInstanceState.PROGRAM_REJECTED': 'Program Rejected',
  'TAS.ProgramInstanceState.PROGRAM_NOT_APPROVED': 'Program Not Approved',
  'TAS.ProgramInstanceState.PRIMED': 'In Progress',
  'TAS.ProgramInstanceState.PENDING_COMPLETION_APPROVAL': 'Pending Completion Approval',
  'TAS.ProgramInstanceState.COMPLETION_APPROVED': 'Completion Approved',
  'TAS.ProgramInstanceState.COMPLETION_REJECTED': 'Completion Rejected',
  'TAS.ProgramInstanceState.COMPLETION_NOT_APPROVED': 'Completion Not Approved',
  'TAS.ProgramInstanceState.PENDING_WITHDRAWAL_APPROVAL': 'Pending Withdrawal Approval',
  'TAS.ProgramInstanceState.WITHDRAWAL_APPROVED': 'Withdrawal Approved',
  'TAS.ProgramInstanceState.WITHDRAWAL_REJECTED': 'Withdrawal Rejected',
  'TAS.ProgramInstanceState.WITHDRAWAL_NOT_APPROVED': 'Withdrawal Not Approved',
  'TAS.ProgramInstanceState.COMPLETED': 'Completed',
  'TAS.ProgramInstanceState.WITHDRAWN': 'Withdrawn',
  'TAS.ProgramInstanceState.ABANDONED': 'Canceled',
};

const ENUM_FIELD_REGISTRY: Record<string, Record<string, string>> = {
  // snake_case (fallback fields / OS source paths)
  tas_application_state_keyword: tasStateLabelMap,
  application_state: tasStateLabelMap,
  tas_application_payment_state_keyword: tasStateLabelMap,
  tas_program_instance_state_keyword: TAS_PROGRAM_INSTANCE_STATE_LABELS,
  // camelCase (/fields API response)
  tasApplicationStateKeyword: tasStateLabelMap,
  applicationState: tasStateLabelMap,
  tasApplicationPaymentStateKeyword: tasStateLabelMap,
  tasProgramInstanceStateKeyword: TAS_PROGRAM_INSTANCE_STATE_LABELS,
};

export function getEnumFormatForField(fieldKey: string): EnumFormatConfig | undefined {
  const valueMap = ENUM_FIELD_REGISTRY[fieldKey];
  if (!valueMap) return undefined;
  return { type: 'enum', valueMap };
}

export function isEnumField(fieldKey: string): boolean {
  return fieldKey in ENUM_FIELD_REGISTRY;
}
